<div class="geometry-container">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div style="font-weight: bold">
      @if (geometryType === 0) {
        <label>Punkt</label>
      }
      @if (geometryType === 1) {
        <label>Linie</label>
      }
      @if (geometryType === 2) {
        <label>Polygon</label>
      }
    </div>
    <div class="fab-group">
      @if (fabTogglerState === 'active') {
        @for (btn of buttons; track btn) {
          <button
            mat-mini-fab
            class="fab-secondary"
            color="primary"
            [disabled]="isButtonDisabled(btn)"
            matTooltip="{{ btn.tooltip }}"
            (click)="btn.onClick()"
            >
            <mat-icon class="iconStyle">{{ btn.icon }}</mat-icon>
          </button>
        }
      }

      <button mat-mini-fab class="fab-toggler" (click)="onToggleFab()">
        <mat-icon class="material-icons md1" [@fabToggler]="fabTogglerState">reorder</mat-icon>
      </button>
    </div>
  </div>
  <!-- <div class="geometry-selection" fxLayout="row" fxLayoutAlign="end center"></div> -->
  @if (geometryType === 0) {
    <div class="coordinates-section">
      @if (geometryType === 0) {
        <label>Koordinaten:</label>
      }
      @if (geometryType === 0) {
        <div fxLayout="row" fxLayoutGap="10px" class="coordinate-inputs">
          <abc-text-box
            #xCoordinateInput
            (change)="onXCoordinateChange(xCoordinate)"
            [(ngModel)]="xCoordinate"
            [labelMode]="'floating'"
            [label]="'X'"
            [readOnly]="false"
            [validationStatus]="'valid'"
            [width]="'160'"
          ></abc-text-box>
          <abc-text-box
            #yCoordinateInput
            (change)="onYCoordinateChange(yCoordinate)"
            [(ngModel)]="yCoordinate"
            [labelMode]="'floating'"
            [label]="'Y'"
            [readOnly]="false"
            [validationStatus]="'valid'"
            [width]="'160'"
          ></abc-text-box>
        </div>
      }
    </div>
  }
  @if (geometryType === 1) {
    <div>
      @if (geometryType === 1) {
        <label>
          {{ isLineFinished ? 'Linienerfassung abgeschlossen.' : 'Linienerfassung ...' }}
        </label>
      }
      @if (geometryType === 1 && !isLineFinished) {
        <abc-button
          [stylingMode]="'outlined'"
          [text]="'Fertig'"
          [width]="'100px'"
          (click)="finishDrawing()"
        ></abc-button>
      }
    </div>
  }
  @if (geometryType === 2) {
    <div>
      @if (geometryType === 2) {
        <label>
          {{ isPolygonFinished ? 'Flächenerfassung abgeschlossen.' : 'Flächenerfassung ...' }}
        </label>
      }
      @if (geometryType === 2 && !isPolygonFinished) {
        <abc-button
          [stylingMode]="'outlined'"
          [text]="'Fertig'"
          [width]="'100px'"
          (click)="finishDrawing()"
        ></abc-button>
      }
    </div>
  }
  @if (showMissingCoordinatesWarning) {
    <div style="color: red; margin-top: 8px">
      Die Geometrie muss vor dem Speichern erfasst werden.
    </div>
  }
</div>
